/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import _ from "lodash";
import { useState, useRef, useCallback, useEffect } from "react";
import { Box, ListItemButton, ListItemText, Typography } from "@mui/material";
import { LuiSemanticIndicator, Alert } from '@jda/lui-common-component-library-mui5';
import { useStyles } from "./styles";
import { TITLES } from "./constants";
import Loader from "../../shared/loader/Loader";
import useWindowDimensions from "../../shared/windowDimensions/windowDimensions";
import { Tokens } from "@jda/lui-common-component-library-mui5";
interface ICustomSearchListProps {
  list: any;
  selectedItem: any;
  pagination: any;
  onSelectItem: Function;
  setOpenList: Function;
  goToTheNextPage?: Function
}

const CustomSearchList = (props: ICustomSearchListProps) => {
  const { list, selectedItem, onSelectItem, goToTheNextPage, pagination, setOpenList } = props;

  const classes = useStyles();
  const observerLeftPanel: any = useRef();
  const { height } = useWindowDimensions();

  const [loading, setLoading] = useState(false);
  const [listOpened, setListOpened] = useState(false);

  const lastElementRefLeftPanel = useCallback((node) => {
    // pagination logic
    if (observerLeftPanel.current) observerLeftPanel.current.disconnect();
    observerLeftPanel.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        setLoading(true);
        // trigger page change on last element
        // if total customerList are more than current customer customerList
        if (pagination.totalCount > list.length) {
          goToTheNextPage && goToTheNextPage(pagination.pageNumber + 1);
          setLoading(false);
        } else {
          setLoading(false);
        }
      }
    });
    if (node) observerLeftPanel.current.observe(node);
  }, [list]);

  useEffect(() => {
    setListOpened(true);
  }, []);

  useEffect(() => {
    if (listOpened) {
      document.addEventListener("click", (_event) => {
        _event.stopPropagation();
        // Close the list when clicking outside
        setOpenList(false);
      });
      return () => {
        document.removeEventListener("click", () => {
          setOpenList(false);
        });
      };
    }
  }, [listOpened]);

  const onClickSelectItem = (ev, item: any) => {
    onSelectItem(ev, item);
  };

  list.forEach(item => {
    item.name = item.jpowerid ? `${item.name + " (" + item.jpowerId + ") "}` : item.name;
  });

  return (
    <Box className={classes.listWrapperStyle}>
      <Box className={classes.listPanel}>
        <Box className={classes.listView}>
          <Box maxHeight={height - 400}>
            {list.length ? (
              list.map((item: any, index: number) => {
                // const displayName = item.name + (item.jpowerId ? " (" + item.jpowerId + ") " : "");
                return (
                  <ListItemButton
                    key={index}
                    onClick={(ev) => onClickSelectItem(ev, item)}
                    data-testid={`left-panel-dimension-${index}`}
                    className={classes.listItem}
                  >
                    {item.id === selectedItem.id &&
                      <LuiSemanticIndicator
                        percentValue={100}
                        thickness={5}
                        customStyles={{
                          backgroundColor: Tokens.colors.lightTheme.primaryMain
                        }}
                      />
                    }
                    {list.length === index + 1 ? (
                      <ListItemText className={classes.listItemText} ref={lastElementRefLeftPanel} primary={item.name} secondary={item.jpowerId ? item.jpowerId : ''} />
                    ) : (
                      <ListItemText className={classes.listItemText} primary={item.name} secondary={item.jpowerId ? item.jpowerId : ''} />
                    )}
                  </ListItemButton>
                );
              })
            ) : (
              <Box className={classes.noItemsFound}>
                <Typography className={classes.noItemsFoundText}>{TITLES.NO_ITEMS_FOUND}</Typography>
              </Box>
            )}
            {loading && (
              <Box alignContent={"center"}>
                <Loader showLoader={true} isCenter />
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default CustomSearchList;
